import Homepage from '@/components/pages/Home'
import Login from '@/components/pages/Login'
import Settings from '@/components/pages/Blitz/Settings'
import SettingsErrors from '@/components/pages/Blitz/Settings/errors.vue'
import SettingsInstruction from '@/components/pages/Blitz/Settings/instruction.vue'
import SettingsButton from '@/components/pages/Blitz/Settings/button.vue'
import BlitzForm from '@/components/pages/Blitz/Settings/blitzFormConstructor.vue'
import BlitzInvitation from '@/components/pages/BlitzInvitation'
import BlitzSingleInvitation from '@/components/pages/BlitzInvitation/single'
import BlitzMultipleInvitation from '@/components/pages/BlitzInvitation/multiple'
import Users from '@/components/pages/Users'
import UsersActions from '@/components/pages/UsersActions'
import BlitzList from '@/components/pages/BlitzList'
import Packages from '@/components/pages/Packages'
import PackageList from '@/components/pages/Packages/packageList.vue'
import Predefined from '@/components/pages/Packages/predefined.vue'
import Gallery from '@/components/pages/Gallery'
import Categories from '@/components/pages/Categories'
import ApprovedCompanies from '@/components/pages/Blitz/approved-companies'
import DisplaySettings from '@/components/pages/Blitz/display-settings'
import Locations from '@/components/pages/Agenda/Locations'
import FakeBlitzRegistration from 'pages/FakeBlitzRegistration'
import Registration from '@/components/pages/Registration'
import VIPInvitationSingle from '@/components/pages/Registration/Invitation/single'
import VIPInvitationMultiple from '@/components/pages/Registration/Invitation/multiple'
import VIPInvitationBatched from '@/components/pages/Registration/Invitation/batched'
import CryptoTraderInvitation from '@/components/pages/Registration/Invitation/crypto-trader'
import RegistrationVIPInvitation from '@/components/pages/Registration/Invitation'
import Sessions from '@/components/pages/Agenda/Sessions'
import AgendaSettings from '@/components/pages/Agenda/Settings'
import AgendaEventsSettings from '@/components/pages/Agenda/EventsSettings'
import Agenda from '@/components/pages/Agenda'
import Videos from '@/components/pages/Videos'
import VideosList from '@/components/pages/Videos/List'
import VideosDisplaySettings from '@/components/pages/Videos/Display'
import Venue from '@/components/pages/Venue/index'
import BookHotel from '@/components/pages/Venue/BookHotel'
import Banners from '@/components/pages/Banners'
import BannersList from '@/components/pages/Banners/List'
import BannersDisplaySettings from '@/components/pages/Banners/Display'
// import AttendeeTypeVip from '@/components/pages/Registration/Settings/vip'
import Speakers from 'pages/Speakers'
import Sponsors from '@/components/pages/Sponsors'
import SponsorsList from '@/components/pages/Sponsors/SponsorsList'
import SponsorsSettings from '@/components/pages/Sponsors/Settings'
import SponsorsDisplay from '@/components/pages/Sponsors/Display'
import FloorPlan from '@/components/pages/Sponsors/FloorPlan'
import SponsorTypes from '@/components/pages/Sponsors/Settings/SponsorsTypes'
import SponsorsTasks from '@/components/pages/Sponsors/Settings/SponsorsTasks'
import SponsorTiers from '@/components/pages/Sponsors/Settings/SponsorTiers'
import SponsorsMediaKits from '@/components/pages/Sponsors/Settings/SponsorsMediaKits'
import SponsorsMediaKitsSettings from '@/components/pages/Sponsors/Settings/MediaKitSettings'
import SpeakersForm from 'pages/Speakers/Form'
import SpeakersTable from 'pages/Speakers/Table'
import SpeakersOrder from 'pages/Speakers/Orders'
import SpeakersPage from 'pages/Speakers/PageSettings'
import SpeakersForHomePage from 'pages/Speakers/SpeakersForHomePage'
import GlobalSettings from '@/components/pages/GeneralSettings/GlobalSettings'
import GoogleSheets from '@/components/pages/GeneralSettings/GoogleSheets'
import GooglePixel from '@/components/pages/GeneralSettings/GooglePixel'
import Awards from '@/components/pages/Awards'
import AwardsCategories from '@/components/pages/Awards/Categories'
import Attendee from '@/components/pages/Registration/Attendee'
import VipInvitation from '@/components/pages/Registration/Attendee/VipInvitation/index.vue'
import Invoices from '@/components/pages/Registration/Invoices/index.vue'
import Nominee from '@/components/pages/Awards/Nominee'
import PromoCodes from '@/components/pages/PromoCodes'
import StaticPages from '@/components/pages/StaticPages'
import staticPageContent from '@/components/pages/StaticPages/Content'
import staticPageContentPages from '@/components/pages/StaticPages/pageContent'
import TestimonialsHomePage from '@/components/pages/StaticPages/Testimonials.vue'
import VoucherPage from '@/components/pages/StaticPages/VoucherPage.vue'
import StatusChecker from '@/components/pages/StaticPages/StatusChecker.vue'
import EmailTemplate from '@/components/pages/EmailTemplate'
import PhotoGallery from '@/components/pages/PhotoGallery'
import CookiesAlert from '@/components/pages/GeneralSettings/CookiesAlert'
import EmailRestriction from '@/components/pages/GeneralSettings/EmailRestriction'
import GeneralSettings from '@/components/pages/GeneralSettings'
import StylesSettings from '@/components/pages/GeneralSettings/StylesSettings'
import Testimonials from '@/components/pages/Testimonials'
import TestimonialsTypes from '@/components/pages/Testimonials/TestimonialsTypes'
import TestimonialsList from '@/components/pages/Testimonials/TestimonialsList'
import TestimonialsDisplaySettings from '@/components/pages/Testimonials/TestimonialsDisplaySettings'
import SEO from '@/components/pages/GeneralSettings/SEO'

import RegistrationSettings from 'pages/Registration/Settings'
import RegistrationBlockedIps from '@/components/pages/Registration/Settings/blockedIps'
import RegistrationErrorMessages from '@/components/pages/Registration/Settings/errors'
import RegistrationMessages from '@/components/pages/Registration/Settings/messages'
import VatIdSettings from '@/components/pages/Registration/Settings/VatIdSettings'
import blockAttendeeSettings from '@/components/pages/Registration/Settings/blockAttendeeSettings'
import AttendeeRegistrationRemind from '@/components/pages/Registration/Settings/AttendeeRegistrationRemind/index.vue'
import passwordSettings from '@/components/pages/Registration/Settings/passwordSettings'
import FCAttendeeRegistration from '@/components/pages/Registration/Settings/FormConstuctorRegistrationAttendee'
import StatusSettings from '@/components/pages/Registration/Settings/statusSettings'
import FAPage from '@/components/pages/Registration/FeatureAttendee'
import FAPageSettings from '@/components/pages/Registration/FeatureAttendee/FAPageSettings'
import FAFormConstructor from '@/components/pages/Registration/FeatureAttendee/FAFormConstructor'
import KillerFeature from '@/components/pages/Registration/KillerFeature'
import KFAll from '@/components/pages/Registration/KillerFeature/KFAll'
import KFBuy from '@/components/pages/Registration/KillerFeature/KFBuy'
import KFSell from '@/components/pages/Registration/KillerFeature/KFSell'
import regularAttendeeType from '@/components/pages/Registration/Attendee/regularAttendeeType'
import VipAttendeeType from '@/components/pages/Registration/Attendee/VipAttendeeType'
import BlackList from '@/components/pages/Registration/Attendee/blackList'
import AwardsSettings from '@/components/pages/Awards/Settings'
import AwardsFormAdditionslFields from '@/components/pages/Awards/Settings/AwardsFormConstructor'
import AwardsSettingsStepOne from '@/components/pages/Awards/Settings/StepOne'
import AwardsSettingsStepTwo from '@/components/pages/Awards/Settings/StepTwo'
import AwardsSettingsStepOneIndividual from '@/components/pages/Awards/Settings/StepOneIndividual'
import AwardsSettingsStepTwoIndividual from '@/components/pages/Awards/Settings/StepTwoIndividual'
import AwardsSettingsGeneral from '@/components/pages/Awards/Settings/General'
import AwardsSettingsWinners from '@/components/pages/Awards/Settings/Winners'
import AwardsSettingsIndividual from '@/components/pages/Awards/Settings/Individual'
import AwardsSettingsWelcome from '@/components/pages/Awards/Settings/Welcome'
import AwardsVoting from '@/components/pages/Awards/Voting'
import AwardsVotingStepOne from '@/components/pages/Awards/Voting/StepOne'
import AwardsVotingStepTwo from '@/components/pages/Awards/Voting/StepTwo'
import AwardsVotingStepOneIndividual from '@/components/pages/Awards/Voting/StepOneIndividual'
import AwardsVotingStepTwoIndividual from '@/components/pages/Awards/Voting/StepTwoIndividual'
import AwardsVotingVotes from '@/components/pages/Awards/Voting/Votes'
import AwardsReminders from '@/components/pages/Awards/Reminders'
import EmailNotificationsSettings from 'pages/EmailNotificationsSettings'
import AdminNotificationsSettings from 'pages/EmailNotificationsSettings/AdminNotificationsSettings'
import AttendeeNotificationsSettings from 'pages/EmailNotificationsSettings/AttendeeNotificationsSettings'

import ListingSettings from '@/components/pages/Listing/ListingSettings'
import ListingSettingsInstruction from '@/components/pages/Listing/ListingSettings/instruction.vue'
import ListingFormConstructor from '@/components/pages/Listing/ListingSettings/listingFormConstructor.vue'
import ListingSettingsErrors from '@/components/pages/Listing/ListingSettings/errors.vue'
import ListingSettingsSubmitModal from '@/components/pages/Listing/ListingSettings/submitModal.vue'
import ListingSettingsButton from '@/components/pages/Listing/ListingSettings/button.vue'
import ListingThankYouPage from '@/components/pages/Listing/ListingSettings/thankYouPage.vue'

import ListingInvitation from '@/components/pages/Listing/ListingInvitation'
import ListingSingleInvitation from '@/components/pages/Listing/ListingInvitation/single.vue'
import ListingMultipleInvitation from '@/components/pages/Listing/ListingInvitation/multiple.vue'

import ListingList from '@/components/pages/Listing/ListingList'
import PlaceholderTextSettings from '@/components/pages/Registration/Settings/PlaceholderTextSettings.vue'
import AllAttendee from '@/components/pages/Registration/Attendee/AllAttendee'
import CryptoTrader from '@/components/pages/Registration/Attendee/CryptoTrader'

import AttendeeMessages from '@/components/pages/Registration/Attendee/AttendeesMessages/index.vue'
import EventsNotificationsSettings from '@/components/pages/EmailNotificationsSettings/EmailTemplatesSettings'

import AllAttendeesMessages from '@/components/pages/AttendeesMessages'

import RegularInvitation from '@/components/pages/Registration/Attendee/RegularInvitation/index.vue'

import PasswordSetting from '@/components/pages/PasswordSetting'

import PersonalInformation from '@/components/pages/PersonalInformation'

export const routes = [
  {
    path: '/',
    name: 'Homepage',
    component: Homepage,
    children: [
      {
        path: '/personal-information',
        name: 'PersonalInformation',
        component: PersonalInformation,
        meta: { roleScope: ['manager', 'master', 'super_admin'] }
      },
      {
        path: 'users',
        name: 'Users',
        component: Users,
        meta: { roleScope: ['master', 'super_admin'] }
      },
      {
        path: 'actions',
        name: 'Users actions',
        component: UsersActions,
        meta: { roleScope: ['super_admin'] }
      },
      {
        path: 'categories',
        name: 'Categories',
        component: Categories,
        meta: { roleScope: ['master', 'super_admin'] }
      },
      {
        path: '/agenda',
        name: 'Agenda',
        redirect: '/agenda/locations',
        component: Agenda,
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'locations',
            name: 'Locations',
            component: Locations,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'sessions',
            name: 'Agenda Sessions',
            component: Sessions,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'settings',
            name: 'Agenda Settings',
            component: AgendaSettings,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'events-settings',
            name: 'Agenda Events Settings',
            component: AgendaEventsSettings,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/general-settings',
        name: 'general-settings',
        redirect: '/general-settings/cookies-alert',
        component: GeneralSettings,
        meta: { roleScope: ['master', 'super_admin'] },
        children: [
          {
            path: 'cookies-alert',
            name: 'cookies-alert',
            component: CookiesAlert,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'email-restriction',
            name: 'email-restriction',
            component: EmailRestriction,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'global-settings',
            name: 'global-settings',
            component: GlobalSettings,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'seo',
            name: 'seo',
            component: SEO,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'google-sheets',
            name: 'google-sheets',
            component: GoogleSheets,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'google-pixel',
            name: 'google-pixel',
            component: GooglePixel,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'styles-settings',
            name: 'styles-settings',
            component: StylesSettings,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/venue-page',
        name: 'Venue',
        component: Venue,
        meta: { roleScope: ['master', 'super_admin'] },
        children: [
          {
            path: 'book-hotel',
            name: 'book-hotel',
            component: BookHotel,
            meta: { roleScope: ['master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/sponsors',
        name: 'Sponsors',
        redirect: '/sponsors/settings',
        component: Sponsors,
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'sponsors-list',
            name: 'sponsors-list',
            component: SponsorsList,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'settings',
            name: 'sponsors-settings',
            redirect: '/sponsors/settings/types',
            component: SponsorsSettings,
            meta: { roleScope: ['manager', 'master', 'super_admin'] },
            children: [
              {
                path: 'types',
                name: 'types',
                component: SponsorTypes,
                meta: { roleScope: ['manager', 'master', 'super_admin'] }
              },
              {
                path: 'tasks',
                name: 'tasks',
                component: SponsorsTasks,
                meta: { roleScope: ['manager', 'master', 'super_admin'] }
              },
              {
                path: 'tiers',
                name: 'tiers',
                component: SponsorTiers,
                meta: { roleScope: ['manager', 'master', 'super_admin'] }
              },
              {
                path: 'media-kits',
                name: 'media-kits',
                component: SponsorsMediaKits,
                meta: { roleScope: ['manager', 'master', 'super_admin'] }
              },
              {
                path: 'media-kits-settings',
                name: 'media-kits-settings',
                component: SponsorsMediaKitsSettings,
                meta: { roleScope: ['manager', 'master', 'super_admin'] }
              }
            ]
          },
          {
            path: 'display',
            name: 'sponsors-display',
            component: SponsorsDisplay,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'floor-plan',
            name: 'floor-plan',
            component: FloorPlan,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/videos',
        name: 'Videos',
        redirect: '/videos/list',
        component: Videos,
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'list',
            name: 'List',
            component: VideosList,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'display',
            name: 'Display Settings',
            component: VideosDisplaySettings,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/banners',
        name: 'Banners',
        redirect: '/banners/list',
        component: Banners,
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'list',
            name: 'Banner List',
            component: BannersList,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'display',
            name: 'Banner Display Settings',
            component: BannersDisplaySettings,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/packages',
        name: 'Packages',
        component: Packages,
        redirect: '/packages/package-list',
        meta: { roleScope: ['master', 'super_admin'] },
        children: [
          {
            path: 'package-list',
            name: 'package-list',
            component: PackageList,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'predefined',
            name: 'predefined',
            component: Predefined,
            meta: { roleScope: ['master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/media-folder',
        name: 'media-folder',
        component: Gallery,
        meta: { roleScope: ['manager', 'master', 'super_admin'] }
      },
      // Role scopes for Blitz was disabled because FE-2966 to avoid entering user on that page
      {
        path: 'blitz-list',
        name: 'Blitz List',
        component: BlitzList,
        meta: { roleScope: ['manager', 'master', 'super_admin'] }
      },
      {
        path: '/approved-companies',
        name: 'Approved companies',
        component: ApprovedCompanies,
        meta: { roleScope: ['manager', 'master', 'super_admin'] }
      },
      {
        path: '/display-settings',
        name: 'Display settings',
        component: DisplaySettings,
        meta: { roleScope: ['manager', 'master', 'super_admin'] }
      },
      {
        path: '/settings',
        name: 'settings',
        redirect: '/settings/instruction',
        component: Settings,
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'instruction',
            name: 'settings-instruction',
            component: SettingsInstruction,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'blitz-form',
            name: 'settings-form',
            component: BlitzForm,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'errors',
            name: 'settings-errors',
            component: SettingsErrors,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'button',
            name: 'settings-button',
            component: SettingsButton,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/blitz-form',
        name: 'BlitzForm',
        component: BlitzForm,
        meta: { roleScope: ['manager', 'master', 'super_admin'] }
      },
      {
        path: '/invitation',
        name: 'Invitation',
        redirect: '/invitation/single',
        component: BlitzInvitation,
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'single',
            name: 'single-invitation',
            component: BlitzSingleInvitation,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'multiple',
            name: 'multiple-invitation',
            component: BlitzMultipleInvitation,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/registration',
        name: 'registration',
        redirect: '/registration/settings',
        component: Registration, // remove redirect if needed, or change component to root
        meta: { roleScope: ['master', 'super_admin'] },
        children: [
          {
            path: 'settings',
            name: 'registration-settings',
            redirect: '/registration/settings/form-constructor-attendee-registration',
            component: RegistrationSettings,
            meta: { roleScope: ['super_admin'] },
            children: [
              {
                path: 'form-constructor-attendee-registration',
                name: 'form-constructor-attendee-registration',
                component: FCAttendeeRegistration,
                meta: { roleScope: ['super_admin'] }
              },
              {
                path: 'registration-placeholder-settings',
                name: 'registration-placeholder-settings',
                component: PlaceholderTextSettings,
                meta: { roleScope: ['super_admin'] }
              },
              {
                path: 'vatid-settings',
                name: 'vatid-settings',
                component: VatIdSettings,
                meta: { roleScope: ['super_admin'] }
              },
              {
                path: 'error-messages',
                name: 'error-messages',
                component: RegistrationErrorMessages,
                meta: { roleScope: ['super_admin'] }
              },
              {
                path: 'blocked-ips',
                name: 'blocked-ips',
                component: RegistrationBlockedIps,
                meta: { roleScope: ['super_admin'] }
              },
              {
                path: 'form-messages',
                name: 'form-messages',
                component: RegistrationMessages,
                meta: { roleScope: ['super_admin'] }
              },
              {
                path: 'status-settings',
                name: 'status-settings',
                component: StatusSettings,
                meta: { roleScope: ['super_admin'] }
              },
              {
                path: 'attendee-registration-remind',
                name: 'attendee-registration-remind',
                component: AttendeeRegistrationRemind,
                meta: { roleScope: ['super_admin'] }
              },
              {
                path: 'block-attendee-settings',
                name: 'block-attendee-settings',
                component: blockAttendeeSettings,
                meta: { roleScope: ['super_admin'] }
              },
              {
                path: 'password-settings',
                name: 'password-settings',
                component: passwordSettings,
                meta: { roleScope: ['super_admin'] }
              }
            ]
          },
          {
            path: 'featured-attendee',
            name: 'featured attendee',
            redirect: '/registration/featured-attendee/featured-page-settings',
            component: FAPage,
            meta: { roleScope: ['super_admin'] },
            children: [
              {
                path: 'featured-page-settings',
                name: 'featured page settings',
                component: FAPageSettings,
                meta: { roleScope: ['super_admin'] }
              },
              {
                path: 'featured-form-constructor',
                name: 'featured form constructor',
                component: FAFormConstructor,
                meta: { roleScope: ['super_admin'] }
              }
            ]
          },
          {
            path: 'vip-invitation',
            name: 'registration-vip-invitation',
            redirect: '/registration/vip-invitation/single',
            component: RegistrationVIPInvitation,
            meta: { roleScope: ['master', 'super_admin'] },
            children: [
              {
                path: 'single',
                name: 'single',
                component: VIPInvitationSingle,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'multiple',
                name: 'multiple',
                component: VIPInvitationMultiple,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'batched',
                name: 'batched',
                component: VIPInvitationBatched,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'crypto-trader-invitation',
                name: 'crypto-trader-invitation',
                component: CryptoTraderInvitation,
                meta: { roleScope: ['master', 'super_admin'] }
              }
            ]
          },
          {
            path: 'attendee',
            name: 'attendee',
            redirect: '/registration/attendee/all-attendee',
            component: Attendee,
            meta: { roleScope: ['master', 'super_admin'] },
            children: [
              {
                path: 'all-attendee',
                name: 'all-attendee',
                component: AllAttendee,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'crypto-trader',
                name: 'crypto-trader',
                component: CryptoTrader,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'regular-attendee-type',
                name: 'regular-attendee-type',
                component: regularAttendeeType,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'vip-attendee-type',
                name: 'vip-attendee-type',
                component: VipAttendeeType,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'blacklist',
                name: 'blacklist',
                component: BlackList,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'vip-invitation',
                name: 'vip-invitation',
                component: VipInvitation,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'attendees-messages',
                name: 'attendees-messages',
                component: AttendeeMessages,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'regular-invitation',
                name: 'regular-invitation',
                component: RegularInvitation,
                meta: { roleScope: ['master', 'super_admin'] }
              }
            ]
          },
          {
            path: 'killer-feature',
            name: 'killer-feature',
            redirect: '/registration/killer-feature/settings',
            component: KillerFeature,
            meta: { roleScope: ['master', 'super_admin'] },
            children: [
              {
                path: 'settings',
                name: 'killer feature settings',
                component: KFAll,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'buy-tab',
                name: 'buy killer feature tab',
                component: KFBuy,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'sell-tab',
                name: 'sell killer feature tab',
                component: KFSell,
                meta: { roleScope: ['master', 'super_admin'] }
              }
            ]
          },
          {
            path: 'invoices',
            name: 'invoices',
            component: Invoices,
            meta: { roleScope: ['master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/speakers',
        name: 'speakers',
        redirect: '/speakers/table',
        component: Speakers,
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'form',
            name: 'speakers-form',
            component: SpeakersForm,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'table',
            name: 'speakers-table',
            component: SpeakersTable,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'page',
            name: 'speakers-page',
            component: SpeakersPage,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'order',
            name: 'speakers-order',
            component: SpeakersOrder,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'add-for-home-page',
            name: 'speakers-home-page',
            component: SpeakersForHomePage,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/static-pages/',
        name: 'static-pages',
        redirect: '/static-pages/content',
        component: StaticPages,
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'content',
            name: 'static-pages-content',
            component: staticPageContent,
            redirect: '/static-pages/content/home',
            meta: { roleScope: ['manager', 'master', 'super_admin'] },
            children: [
              {
                path: ':page',
                name: 'static-pages-content-pages',
                component: staticPageContentPages,
                meta: { roleScope: ['manager', 'master', 'super_admin'] }
              }
            ]
          },
          {
            path: 'testimonials',
            name: 'Testimonials',
            component: TestimonialsHomePage,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'voucher-page',
            name: 'voucher-page',
            component: VoucherPage,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'status-checker',
            name: 'status-checker',
            component: StatusChecker,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/notifications',
        name: 'email-notifications-settings',
        component: EmailNotificationsSettings,
        redirect: '/notifications/admin-notifications',
        meta: { roleScope: ['master', 'super_admin'] },
        children: [
          {
            path: 'admin-notifications',
            name: 'admin-notifications',
            component: AdminNotificationsSettings,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'attendee-notifications',
            name: 'attendee-notifications',
            component: AttendeeNotificationsSettings,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'events-notifications',
            name: 'events-notifications',
            component: EventsNotificationsSettings,
            meta: { roleScope: ['master', 'super_admin'] }
          }
        ]
      },
      // Role scopes for awards was disabled because FE-2966
      {
        path: '/awards',
        name: 'awards',
        component: Awards,
        redirect: '/awards/categories',
        meta: { roleScope: ['master', 'super_admin'] },
        children: [
          {
            path: 'categories',
            name: 'awards-categories',
            component: AwardsCategories,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'nominees',
            name: 'awards-nominees',
            component: Nominee,
            meta: { roleScope: ['master', 'super_admin'] }
          },
          {
            path: 'settings',
            name: 'awards-settings',
            component: AwardsSettings,
            redirect: '/awards/settings/general',
            meta: { roleScope: ['master', 'super_admin'] },
            children: [
              {
                path: 'general',
                name: 'awards-settings-general',
                component: AwardsSettingsGeneral,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'individual',
                name: 'awards-settings-individual',
                component: AwardsSettingsIndividual,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'welcome',
                name: 'awards-settings-welcome',
                component: AwardsSettingsWelcome,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'step1',
                name: 'awards-settings-step1',
                component: AwardsSettingsStepOne,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'step2-individual',
                name: 'awards-settings-step2-individual',
                component: AwardsSettingsStepTwoIndividual,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'step1-individual',
                name: 'awards-settings-step1-individual',
                component: AwardsSettingsStepOneIndividual,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'step2',
                name: 'awards-settings-step2',
                component: AwardsSettingsStepTwo,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'awards-form-fields',
                name: 'awards-form-fields',
                component: AwardsFormAdditionslFields,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'awards-settings-winners',
                name: 'awards-settings-winners',
                component: AwardsSettingsWinners,
                meta: { roleScope: ['master', 'super_admin'] }
              }
            ]
          },
          {
            path: 'voting',
            name: 'awards-voting',
            component: AwardsVoting,
            redirect: '/awards/voting/step-one',
            meta: { roleScope: ['master', 'super_admin'] },
            children: [
              {
                path: 'step-one',
                name: 'awards-voting-step-one',
                component: AwardsVotingStepOne,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'step-two',
                name: 'awards-voting-step-two',
                component: AwardsVotingStepTwo,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'step-one-individual',
                name: 'awards-voting-step-one-individual',
                component: AwardsVotingStepOneIndividual,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'step-two-individual',
                name: 'awards-voting-step-two-individual',
                component: AwardsVotingStepTwoIndividual,
                meta: { roleScope: ['master', 'super_admin'] }
              },
              {
                path: 'votes',
                name: 'awards-voting-votes',
                component: AwardsVotingVotes,
                meta: { roleScope: ['master', 'super_admin'] }
              }
            ]
          },
          {
            path: 'reminders',
            name: 'awards-reminders',
            component: AwardsReminders,
            meta: { roleScope: ['master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/promo-codes',
        name: 'promo-codes',
        component: PromoCodes,
        meta: { roleScope: ['master', 'super_admin'] }
      },
      {
        path: '/testimonials',
        name: 'testimonials',
        component: Testimonials,
        redirect: '/testimonials/testimonials-types',
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'testimonials-types',
            name: 'testimonials-types',
            component: TestimonialsTypes,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'testimonials-list',
            name: 'testimonials-list',
            component: TestimonialsList,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'testimonials-display',
            name: 'testimonials-display',
            component: TestimonialsDisplaySettings,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/email-template',
        name: 'EmailTemplate',
        component: EmailTemplate,
        meta: { roleScope: ['master', 'super_admin'] }
      },
      {
        path: '/photo-gallery',
        name: 'PhotoGallery',
        component: PhotoGallery,
        meta: { roleScope: ['manager', 'master', 'super_admin'] }
      },
      {
        path: '/listing-settings',
        name: 'listing settings',
        component: ListingSettings,
        redirect: '/listing-settings/instruction',
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'instruction',
            name: 'listing instruction',
            component: ListingSettingsInstruction,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'form',
            name: 'listing form',
            component: ListingFormConstructor,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'thank-you',
            name: 'listing thank you',
            component: ListingThankYouPage,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'submit',
            name: 'submit modal',
            component: ListingSettingsSubmitModal,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'errors',
            name: 'listing errors',
            component: ListingSettingsErrors,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'button',
            name: 'listing button',
            component: ListingSettingsButton,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/listing-invitation',
        name: 'ListingInvitation',
        redirect: '/listing-invitation/single',
        component: ListingInvitation,
        meta: { roleScope: ['manager', 'master', 'super_admin'] },
        children: [
          {
            path: 'single',
            name: 'listing single invitation',
            component: ListingSingleInvitation,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          },
          {
            path: 'multiple',
            name: 'listing multiple invitation',
            component: ListingMultipleInvitation,
            meta: { roleScope: ['manager', 'master', 'super_admin'] }
          }
        ]
      },
      {
        path: '/listing-list',
        name: 'ListingList',
        component: ListingList,
        meta: { roleScope: ['manager', 'master', 'super_admin'] }
      },
      {
        path: '/attendees-messages',
        name: 'Attendees Messages',
        component: AllAttendeesMessages,
        meta: { roleScope: ['master', 'super_admin'] }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/password-setting',
    name: 'PasswordSetting',
    component: PasswordSetting
  },
  {
    path: '/fake-invite-registration',
    name: 'FakeBlitzRegistration',
    component: FakeBlitzRegistration,
    meta: { roleScope: ['master', 'super_admin'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js